import React, { createContext, useRef } from "react";

export const MastheadRefContext = createContext(); 

export const MastheadRefProvider = ({ children }) => {
    

  const mastheadRef = useRef()
  
  return (
    <MastheadRefContext.Provider value={{ mastheadRef }}>
      {children} 
    </MastheadRefContext.Provider>
  );
};
